import { AutoComplete as EJ2AutoComplete } from '@syncfusion/ej2-dropdowns';
import { Base } from './base-module';
/**
 * The `AutoComplete` module is used configure the properties of Auto complete type editor.
 */
export class AutoComplete {
    constructor(parent) {
        this.compObj = undefined;
        this.parent = parent;
        this.parent.atcModule = this;
        this.base = new Base(this.parent, this);
    }
    render(e) {
        this.compObj = new EJ2AutoComplete(this.parent.model);
        this.compObj.appendTo(e.target);
    }
    /**
     * @hidden
     * @returns {void}
     */
    showPopup() {
        this.compObj.focusIn();
        this.compObj.showPopup();
    }
    focus() {
        this.compObj.element.focus();
    }
    updateValue(e) {
        if (this.compObj && e.type === 'AutoComplete') {
            this.parent.setProperties({ value: this.compObj.value }, true);
            this.parent.extendModelValue(this.compObj.value);
        }
    }
    /**
     * Destroys the module.
     *
     * @function destroy
     * @returns {void}
     * @hidden
     */
    destroy() {
        this.base.destroy();
    }
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} - returns the string
     */
    getModuleName() {
        return 'auto-complete';
    }
}
